/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import useReactRouter from "use-react-router";
import { FaFile, FaImage } from "react-icons/fa";
import { gcpUploadDelete } from "../../helper";
import {
  gcp_docs,
  formatDateDash,
  getStaffLogin,
  ITEM_PER_PAGE,
  setParams,
  startOfMonth,
  messageSuccess,
  messageError,
  endOfMonth,
  DisPlayFiles,
} from "../../helper";
import { DELETE_DOCUMENT, QUERY_DOCUMENTS } from "../documents/apollo";
import Pagination from "../../helper/components/pagination/Pagination";
import AddDocPrivate from "./addDocPrivate";
import EditDocPrivate from "./editDocPrivate";
import Notiflix from "notiflix";
import ListDocumentType from "../../helper/components/pagination/DocumentType";

export default function PrivateDocumentsList() {
  const _user = getStaffLogin().data;
  const { history, location } = useReactRouter();
  const queryParams = new URLSearchParams(location?.search);
  const [searchValue, setSearchValue] = useState("");
  const [newLoadData, setNewLoadData] = useState(false);
  const [listData, setListData] = useState([]);
  const [startDate, setStartDate] = useState(startOfMonth());
  const [endDate, setEndDate] = useState(endOfMonth());
  const [numberPage, setNumberPage] = useState(1);
  const [numberRow, setNumberRow] = useState(ITEM_PER_PAGE);
  const [documentType, setDocumentType] = useState([]);

  const [deleteDoc] = useMutation(DELETE_DOCUMENT);
  const [factData, { data: resultData }] = useLazyQuery(QUERY_DOCUMENTS, {
    fetchPolicy: "cache-and-network",
  });
  useEffect(() => {
    factData({
      variables: {
        where: {
          createdAt_gte: startDate ? formatDateDash(startDate) : undefined,
          createdAt_lte: endDate ? formatDateDash(endDate) : undefined,
          isPrivate: 1,
          isDeleted: 0,
          isPublic: 1,
          createdBy: parseInt(_user?._id),
          typeDocument: documentType?._id ? documentType?._id : undefined,
        },
        skip: searchValue ? 0 : numberRow * (numberPage - 1),
        limit: searchValue ? 1000 : numberRow,
        orderBy: "createdAt_DESC",
      },
    });
  }, [numberPage, numberRow, startDate, endDate, newLoadData, documentType]);

  useEffect(() => {
    const results = resultData?.documents?.data || [];
    if (searchValue) {
      const filter = results?.filter((obj) => {
        if (
          obj?.documentID?.includes(searchValue) ||
          obj?.title?.includes(searchValue)
        ) {
          return obj;
        }
      });
      setListData(filter);
    } else {
      setListData(results);
    }
  }, [resultData, searchValue]);

  // page
  useEffect(() => {
    let page = queryParams.get("page");
    let rows = queryParams.get("rows");
    let startDate = queryParams.get("startDate");
    let endDate = queryParams.get("endDate");
    if (page) {
      setNumberPage(parseInt(page));
    } else {
      setNumberPage(1);
    }
    if (rows) {
      setNumberRow(parseInt(rows));
    } else {
      setNumberRow(ITEM_PER_PAGE);
    }
    if (startDate) {
      setStartDate(startDate);
    } else {
      setStartDate(startOfMonth());
    }
    if (endDate) {
      setEndDate(endDate);
    } else {
      setEndDate(endOfMonth());
    }
  }, [queryParams]);

  const countData = resultData?.documents?.total;
  const countPage = [];
  for (var i = 1; i <= Math.ceil(countData / numberRow); i++) {
    countPage.push(i);
  }

  const _deleteDocument = (item) => {
    Notiflix.Confirm.show(
      "ແຈ້ງເຕືອນ",
      "ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ນີ້ແທ້ ຫຼື ບໍ່?",
      "ຕົກລົງ",
      "ຍົກເລີກ",
      async () => {
        try {
          const _deleteDoc = await deleteDoc({
            variables: {
              where: {
                _id: item?._id,
              },
            },
          });
          if (_deleteDoc) {
            const filename = item?.files?.split("/").pop(); // handles '.../foo.png' or 'foo.png'
            if (!filename) {
              messageError("ບໍ່ພົບຊື່ໄຟລ໌");
              return;
            }

            await gcpUploadDelete({
              bucketName: "ansx",
              pathname: "docs",
              filename, 
            });
            messageSuccess("ດຳເນີນການສຳເລັດ");
            setNewLoadData(!newLoadData);
          }
        } catch (error) {
          messageError("ດຳເນີນການບໍ່ສຳເລັດ");
        }
      },
      () => {
        return false;
      }
    );
  };

  return (
    <>
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <h3>ຂໍ້ມູນເອກະສານສ່ວນຕົວ</h3>
        <hr />
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="mb-md-0 mb-2 d-flex align-items-center gap-2">
                  <AddDocPrivate
                    newLoad={newLoadData}
                    setNewLoad={setNewLoadData}
                  />
                  <div className="dropdown me-2">
                    <ListDocumentType
                      getData={(data) => {
                        setDocumentType(data);
                      }}
                      defaultValue={documentType?.title}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center flex-wrap">
                  <div className="dropdown me-2">
                    <input
                      type="text"
                      className="form-control w-100"
                      placeholder="ຊື່ເອກະສານ ຫຼື ລະຫັດເອກະສານ"
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                  </div>
                  <div className="dropdown me-1">
                    <div className="input-group">
                      <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) =>
                          history.push({
                            search: setParams(`startDate`, e.target.value),
                          })
                        }
                      />
                      <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) =>
                          history.push({
                            search: setParams(`endDate`, e.target.value),
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="dropdown me-1">
                    <select
                      className="form-select"
                      onChange={(e) =>
                        history.push({
                          search: setParams(`rows`, e.target.value),
                        })
                      }
                    >
                      <option
                        value={10}
                        selected={numberRow === 10 ? true : false}
                      >
                        10 ລາຍການ
                      </option>
                      <option
                        value={50}
                        selected={numberRow === 50 ? true : false}
                      >
                        50 ລາຍການ
                      </option>
                      <option
                        value={100}
                        selected={numberRow === 100 ? true : false}
                      >
                        100 ລາຍການ
                      </option>
                      <option
                        value={500}
                        selected={numberRow === 500 ? true : false}
                      >
                        500 ລາຍການ
                      </option>
                      <option
                        value={1000}
                        selected={numberRow === 1000 ? true : false}
                      >
                        1000 ລາຍການ
                      </option>
                    </select>
                  </div>
                  <div className="dropdown me-3 pt-2">
                    <Pagination
                      className="mt-2"
                      pageTotal={countPage}
                      currentPage={numberPage}
                      onPageChange={(page) => {
                        history.push({
                          search: setParams(`page`, page),
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h3 className="my-3">
          <FaFile className="me-2" /> ເອກະສານສ່ວນຕົວທັງໝົດ {countData || 0} ໄຟລ໌
        </h3>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4">
          {listData?.map((item) => {
            const ext = item?.files?.split(".").pop()?.toLowerCase();
            const docExts = [
              "pdf",
              "presentation",
              "pptx",
              "ppt",
              "pptm",
              "document",
              "docx",
              "doc",
              "docm",
              "dotx",
              "xlsx",
              "xls",
              "xlsm",
              "sheet",
            ];
            if (!docExts.includes(ext)) return null;

            return (
              <div className="col" key={item?._id ?? item?.files}>
                <div className="card iq-file-manager">
                  <div className="card-body card-thumbnail">
                    <div className="p-3 d-flex justify-content-center align-items-center iq-document rounded bg-body">
                      <DisPlayFiles
                        file={item?.files}
                        className="file"
                        width={100}
                        height={100}
                        item={item}
                      />
                    </div>
                    <div className="mt-2">
                      <div className="d-flex justify-content-between">
                        <div className="small">
                          <i className="icon-clock me-1" /> ວັນທີ່ສ້າງ:{" "}
                          {formatDateDash(item?.createdAt)}
                        </div>
                        <div className="btn-group">
                          <EditDocPrivate
                            data={item}
                            newLoad={newLoadData}
                            setNewLoad={(res) => setNewLoadData(res)}
                          />
                          <a
                            href="javascript:void();"
                            className="ms-3 btn btn-sm btn-icon rounded-circle btn-outline-danger"
                            onClick={() => _deleteDocument(item)}
                          >
                            <i className="icon-trash" />
                          </a>
                        </div>
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-unfold_more" />
                        <div className="mb-0 text-primary fw-bolder me-3">
                          {item?.documentID
                            ? item?.documentID
                            : "No Document ID"}
                        </div>
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-text_fields" />
                        <div className=" mb-0 text-dark me-3">
                          {item?.title?.substring(30)
                            ? item?.title?.substring(0, 30) + "..."
                            : item?.title}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <a
                          className="btn btn-secondary btn-sm w-100 rounded-pill"
                          href={gcp_docs + item?.files}
                          target="_blank"
                        >
                          <i className="icon-open_in_new me-1" />
                          ເປີດໄຟລ໌
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <h4 className="py-3 mb-0">
          <FaImage className="me-2" /> ຮູບພາບ
        </h4>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4">
          {listData?.map((item) => {
            const ext = item?.files?.split(".").pop()?.toLowerCase();
            const imgExts = ["jpeg", "jpg", "png", "gif", "svg"];
            if (!imgExts.includes(ext)) return null;

            return (
              <div className="col" key={item?._id ?? item?.files}>
                <div className="card iq-file-manager">
                  <div className="card-body card-thumbnail">
                    <div className="p-3 d-flex justify-content-center align-items-center iq-document rounded bg-body">
                      <DisPlayFiles
                        file={item?.files}
                        className="file"
                        width={100}
                        height={100}
                        item={item}
                      />
                    </div>
                    <div className="mt-2">
                      <div className="d-flex justify-content-between">
                        <div className="small">
                          <i className="icon-clock me-1" /> ວັນທີ່ສ້າງ:{" "}
                          {formatDateDash(item?.createdAt)}
                        </div>
                        <div className="btn-group">
                          <EditDocPrivate
                            data={item}
                            newLoad={newLoadData}
                            setNewLoad={(res) => setNewLoadData(res)}
                          />
                          <a
                            href="javascript:void();"
                            className="ms-3 btn btn-sm btn-icon rounded-circle btn-outline-danger"
                            onClick={() => _deleteDocument(item)}
                          >
                            <i className="icon-trash" />
                          </a>
                        </div>
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-unfold_more" />
                        <div className="mb-0 text-primary fw-bolder me-3">
                          {item?.documentID
                            ? item?.documentID
                            : "No Document ID"}
                        </div>
                      </div>
                      <div className="d-flex align-items-center text-primary gap-2 mb-2">
                        <i className="icon-text_fields" />
                        <div className=" mb-0 text-dark me-3">
                          {item?.title?.substring(30)
                            ? item?.title?.substring(0, 30) + "..."
                            : item?.title}
                        </div>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <a
                          className="btn btn-secondary btn-sm w-100 rounded-pill"
                          href={gcp_docs + item?.files}
                          target="_blank"
                        >
                          <i className="icon-open_in_new me-1" />
                          ເປີດໄຟລ໌
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
